export const form = {
  formId: "socket-io-form",
  formField: {
    endpointUrl: {
      name: "endpointUrl",
      label: "Endpoint URL",
      type: "readonlyEndpoint",
      placeholder: "",
      errorMsg: "",
    },
    rooms: {
      name: "rooms",
      label: "Rooms your flow will listen to",
      type: "tag",
      placeholder: "Rooms",
      errorMsg: "",
    },
    success: {
      name: "success",
      label: "Success",
      type: "readonlyEndpoint",
      placeholder: "",
      errorMsg: "",
    },
    failure: {
      name: "failure",
      label: "Failure",
      type: "readonlyEndpoint",
      placeholder: "",
      errorMsg: "",
    },
    notes: {
      name: "notes",
      label: "Notes",
      type: "text",
      placeholder: "",
      errorMsg: "",
    },
  },
};
